// ============================================================================
// JARVISTRAVEL - OFFLINE NOTICE (JAR-314 degradation)
// The compact inline companion to BackendUnavailableBanner: sits inside a
// form or modal, right beside the action it explains (a paused save, an auth
// submit that will retry). Same amber state-accent vocabulary as the banner.
// Deliberately NOT a live region — the app-wide banner owns the screen-reader
// announcement; a second one would double-speak every outage.
// ============================================================================

import { CloudOff } from 'lucide-react';
import { useBackendStatus } from '@/app/hooks';

interface OfflineNoticeProps {
  /** Surface-specific copy; the default suits inline retryable actions. */
  message?: string;
  className?: string;
}

export function OfflineNotice({
  message = 'Can’t reach our servers right now. Check your connection and try again.',
  className = '',
}: OfflineNoticeProps) {
  const status = useBackendStatus();
  if (status === 'online') return null;

  return (
    <div className={`flex items-start gap-2 rounded-xl border border-warning/20 bg-warning/10 px-3 py-2.5 ${className}`}>
      <CloudOff className="w-4 h-4 mt-0.5 shrink-0 text-warning" strokeWidth={2} aria-hidden="true" />
      <p className="text-sm text-body leading-snug">{message}</p>
    </div>
  );
}

export default OfflineNotice;
